import React, { Component } from "react";
import Slider from "react-slick";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} sliderTreatmentButton`}
      style={{ ...style, top: "47.5%", right: "-6rem" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} sliderTreatmentButton`}
      style={{ ...style, top: "47.5%", left: "-6rem" }}
      onClick={onClick}
    />
  );
}
const settings = {
  className: "testimonialSlider",
  slidesToShow: 1,
  centerMode: false,
  arrows: true,
  dots: false,
  autoplay: 10000,
  centerPadding: 0,
  swipeToSlide: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};
class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.service = null;
    this.map = null;
    this.state = { review: [] };
  }

  componentDidMount() {
    this.loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyAyJmPkUgEvArgapB0QLLUeGWu8TB51nHA&libraries=places`,
      () => this.initMap()
    );
  }

  initMap = () => {
    const latLong = new window.google.maps.LatLng(-33.867, 151.195);
    const element = document.createElement("div");
    element.id = "map";
    element.style.display = "none";
    document.body.append(element);

    this.map = new window.google.maps.Map(document.getElementById("map"), {
      center: latLong,
      zoom: 15,
    });
    var request = {
      placeId: "ChIJJT8ydZoYbW0R8sIkuEsUGwY",
    };

    this.service = new window.google.maps.places.PlacesService(this.map);
    this.service.getDetails(request, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        this.setState({ review: place.reviews });
      }
    });
  };

  loadScript = (url, callback) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  render() {
    return (
      <div className="section section-padding pt-5">
        <div className="container">
          <h3 className="title text-center pb-3" style={{ fontSize: "50px" }}>
            Our Wellness Stories
          </h3>
          <Slider {...settings}>
            {this.state.review.length > 0 &&
              this.state.review.map((item, i) => (
                <div key={i} className="sigma_testimonial bg-gray style-13">
                  <div className="sigma_testimonial-thumb">
                    <img src={item.profile_photo_url} alt={item.author_name} />
                    <span className="fas fa-quote-left sigma_testimonial-icon" />
                  </div>
                  <div className="sigma_testimonial-body">
                    <p className="lineClamp">"{item.text}"</p>
                    <div className="sigma_author-block">
                      <h5 style={{ textTransform: "capitalize" }}>
                        {item.author_name}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default Testimonials;
